module.exports = __webpack_public_path__ + "static/bigminer-tech-qr-a25af3d24a117b20baa7b9d7196f0673.png";